import React from 'react';
import _ from 'lodash';
class BreadCrumb extends React.Component {
    render(){
        let {product} = this.props,
        {parents} = product,
        navParent = [];
        if(parents && parents.length)
        {
            parents = _.orderBy(parents, ['level'],['desc']);
            navParent = parents.map((item, index)=>{
                return (
                    <li key={index} className="breadcrumb-item">
                        <a href={item.url} title={item.title}>{item.title}</a>
                            <span></span>
                    </li>
                )
            });
        }
        navParent.push(<li key='cateid' className="breadcrumb-item">
                        <a href={product.info.category_url} title={product.info.category_name}>{product.info.category_name}</a>
                    </li>)
        return (
            <div className="container">
                <div className="row">
                    <div className="breadcrumbs">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/" title="Tới trang chủ">Trang chủ</a>
                                    <span></span>
                                </li>
                            {navParent}
                            <li className="breadcrumb-item">
                                    <strong>{product.info.title}</strong>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        );
    }
}
export default BreadCrumb;